import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ } from "../data/content";

export const FAQSection = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-secondary/40 border-y border-border"
    >
      <div className="mx-auto max-w-4xl px-5 md:px-8">
        <div className="text-center">
          <div className="text-xs tracking-[0.2em] uppercase text-royal-800 font-semibold">
            Perguntas frequentes
          </div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl text-royal-900 leading-tight">
            Tudo o que você <br /> precisa saber.
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-12 space-y-3"
          data-testid="faq-accordion"
        >
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-border rounded-xl bg-white px-5 data-[state=open]:border-royal-800/40"
            >
              <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl text-royal-900 py-5 hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-foreground/75 text-[15px] leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
